export default {"src":"/sg/_next/static/media/Shipping&Delivery.74ad3fa0.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};